import React from 'react';
import { CHILD_PROPS_TO_USE } from '../constants';

const buildChildProps = (childProps, parentProps) => {
  const propsToOverride = {};
  CHILD_PROPS_TO_USE.forEach(prop => (propsToOverride[prop] = childProps[prop]));
  return { ...parentProps, ...propsToOverride };
};

const renderChildren = (children, otherProps = {}) =>
  React.Children.map(children, child => {
    const childrenElements = child.props.children;
    if (Array.isArray(childrenElements) && childrenElements.length) {
      const [, nestedChildren] = child.props.children;
      return (
        Array.isArray(nestedChildren) &&
        nestedChildren.map(nestedChild => renderChildren(nestedChild, otherProps))
      );
    }
    const childProps = buildChildProps(child.props, otherProps);
    return React.cloneElement(child, { ...childProps });
  });

export default renderChildren;
